import Suscription from './Suscription'

export default Suscription
